import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const Header = () => {

  const[menu, setMenu] = useState(false);

  return (
    <div id='nav-wrapper'>
      <img id="logo" src="/images/logo.png" width="220px" alt="logo" />
      <img id="menu-btn" src='/svg/menu.svg' alt='menu' onClick={() => setMenu(!menu)} />
      <div id="links">
          <Link className='link' to="/">Home</Link>
          <Link className='link' to="/solution">Solution</Link>
          <Link className='link' to="/benefits">Benefits</Link>
          <Link className='link' to="/pricing">Pricing</Link>
          <div style={{justifyContent : "start"}} id="btn-wrapper">
            <button id='nav-outline' className='outline'>Talk To Sales</button>
            <button id='nav-login-btn'>Login</button>
            <button id='nav-contained'>Get Started</button>
          </div>
      </div>
      <div style={{display : `${menu ? 'flex' : 'none'}`}} id="menu">
        <p style={{color : "#FE8C2C", fontSize : "1.5em"}} onClick={() => setMenu(false)}>X</p>
        <Link className='link nav-link-anim' to="/">Home</Link>
        <Link className='link nav-link-anim' to="/solution">Solution</Link>
        <Link className='link nav-link-anim' to="/benefits">Benefits</Link>
        <Link className='link nav-link-anim' to="/pricing">Pricing</Link>
        <div style={{alignItems : "initial"}} id="btn-wrapper">
          <button id='nav-outline' className='outline nav-link-anim'>Talk To Sales</button>
          <button id='nav-login-btn' className='outline nav-link-anim'>Login</button>
          <button id='nav-contained' className='nav-link-anim'>Get Started</button>
        </div>
      </div>
    </div>
  )
}

export default Header
